<template>
	<v-card>
		<v-toolbar color="grey" dark flat> 
			<v-btn icon v-on:click="cerrar" > <i class="fa fa-times"></i></v-btn>
			<v-spacer></v-spacer>
			<v-card-title> Informacion del Usuario</v-card-title>
		</v-toolbar>
    <v-card-text >
			<v-form ref="form" lazy-validation>
				<v-text-field v-model="user.username" label="Nombre de Usuario" ></v-text-field>
				<v-text-field v-if="agregarPass" v-model="passwordAux" label="Contraseña" ></v-text-field>
				<v-text-field v-model="user.nombre" label="Nombre" ></v-text-field>
				<v-text-field v-model="user.a_paterno" label="Primer Apellido" ></v-text-field>
				<v-text-field v-model="user.a_materno" label="Segundo Apellido" ></v-text-field>
				<v-switch v-model="user.activo" label="Usuario Activo" ></v-switch>
				<v-select v-model="user.rol" label="Rol" :items="roles"></v-select>
			</v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red" v-on:click="cerrar" >
        Cancelar
      </v-btn>
      <v-btn color="primary" v-on:click="guardarUser" >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
	import Schema from '../../core/Schema';
	import Helper from '../../core/Helper';
  export default {
    components:{},
    props: {
			user: {
				type: Object,
				default() { return {
					id:null,
					username:null,
					password:null,
					nombre:null,
					a_paterno:null,
					a_materno:null,
					activo:null,
					rol:null,
				};}
			},
		},
    data () { return {
			roles:['capturista','cajero','produccion','reparto','admin','tablajero','inventario'],
			passwordAux:null,
		};},
		mounted() {},
    methods: {
			guardarUser() {
				if(this.agregarPass) {
					this.user.password = Helper.hash(this.passwordAux);
				}
				this.user.activo = this.user.activo?1:0;
				console.log("user antes de guardar", this.user);
				Schema.models.User.guardar(this.user,'all', job => {
					this.$emit('getuser',job.newData);
				});
			},
			cerrar() {
				this.$emit('getuser',null);
			},
		},
		computed: {
			agregarPass() {
				return !this.user.password;
			},
		},
		watch: {}
  }
</script>
<style>
</style>
